// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"InActive_btnContainer_3SDl5","container":"InActive_container_TI8jj","formContainer":"InActive_formContainer_2qNIA","textContainer":"InActive_textContainer_1IBiD"};